import { render, staticRenderFns } from "./service-center.vue?vue&type=template&id=648f4ff4&scoped=true&"
import script from "./service-center.vue?vue&type=script&lang=js&"
export * from "./service-center.vue?vue&type=script&lang=js&"
import style0 from "./service-center.vue?vue&type=style&index=0&id=648f4ff4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f4ff4",
  null
  
)

export default component.exports